<script lang="ts">import { cfgGoogleAnalytics, cfgGoogleClientId, cfgGoogleTagManager } from "@infinitro/config";
import { stage, Stage } from "@infinitro/global";
import { onMount } from "svelte";
const GOOGLE_CLIENT_ID = cfgGoogleClientId();
const GOOGLE_TAG_MANAGER = cfgGoogleTagManager();
const GOOGLE_ANALYTICS = cfgGoogleAnalytics();
let _stage = stage;
// onMount guarantees browser + mounted DOM — inline <script> in svelte:head cannot
// interpolate Svelte variables, so window.GOOGLE_TAG_MANAGER would be read at
// script-execution time and can be undefined if timing is off.
onMount(() => {
	if (![Stage.Prod].includes(_stage)) return;
	if (!(GOOGLE_ANALYTICS || GOOGLE_TAG_MANAGER)) return;
	console.log(`google analytics [${stage}] ${GOOGLE_ANALYTICS}`);
	const dataLayerScript = document.createElement("script");
	dataLayerScript.textContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());`;
	document.head.appendChild(dataLayerScript);
	if (GOOGLE_ANALYTICS && GOOGLE_ANALYTICS !== "undefined") {
		const gaScript = document.createElement("script");
		gaScript.textContent = `gtag('config','${GOOGLE_ANALYTICS}');`;
		document.head.appendChild(gaScript);
	}
	if (!GOOGLE_TAG_MANAGER || GOOGLE_TAG_MANAGER === "undefined") return;
	const configScript = document.createElement("script");
	configScript.textContent = `gtag('config','${GOOGLE_TAG_MANAGER}');`;
	document.head.appendChild(configScript);
	const gtmScript = document.createElement("script");
	gtmScript.async = true;
	gtmScript.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GOOGLE_TAG_MANAGER}');`;
	document.head.appendChild(gtmScript);
});
</script>

<svelte:head>
	{#if ![Stage.Local].includes(_stage)}
		{#if GOOGLE_CLIENT_ID}
			<meta name="google-signin-client_id" content={GOOGLE_CLIENT_ID} />
		{/if}
		{#if GOOGLE_ANALYTICS && GOOGLE_ANALYTICS !== 'undefined'}
			<script
				async
				src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS}`}
			></script>
		{/if}
	{/if}
</svelte:head>

{#if GOOGLE_TAG_MANAGER && GOOGLE_TAG_MANAGER !== 'undefined' && ![Stage.Local].includes(_stage)}
	<noscript
		><iframe
			title="Google Tag Manager"
			src={`https://www.googletagmanager.com/ns.html?id=${GOOGLE_TAG_MANAGER}`}
			height="0"
			width="0"
			style="display:none;visibility:hidden"
		></iframe></noscript
	>
{/if}
